// A bridge for vuex to the notify plugin

// actions
const actions = {
  notify ({}, notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      notification = { 
        message: notification,
        horizontalAlign: 'right',
        verticalAlign: 'top',
        icon: 'nc-icon nc-app',
        type: 'danger'
      };
      this._vm.$notifications.notify(notification)
    } else if (notification.title && (typeof notification.message === 'array' || notification.message instanceof Array)) {
      for (let i = 0; i < notification.message.length; i++) {
        let m = notification.message[i].debugMessage ? notification.message[i].debugMessage : notification.message[i].message
        let n = { 
          message: notification.title + ' ' + m,
          horizontalAlign: 'right',
          verticalAlign: 'top',
          icon: 'nc-icon nc-app',
          type: 'danger'
        };
        this._vm.$notifications.notify(n)
      }

    } else {
      let def = { 
        message: '',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        icon: 'nc-icon nc-app',
        type: 'danger'
      }
      this._vm.$notifications.notify(Object.assign(def, notification))
    }
  }
}

export default {
  actions
}